export default {
    editPaymentMethod: 'editPaymentMethod',
    editBillingInfo: 'editBillingInfo',
    enterpriseBait: 'enterpriseBait',
    reactivatePlan: 'reactivatePlan',
    referralInvitations: 'referralInvitations',
    teamUserInvitation: 'teamUserInvitation',
    teamCancelInvitation: 'teamCancelInvitation',
    teamDeleteMember: 'teamDeleteMember',
    teamConfirmInvitations: 'teamConfirmInvitations',
    accountDeleteConfirm: 'accountDeleteConfirm',
    paywall: 'paywall',
    chromeExtension: 'chromeExtension'
};
